'use strict';

exports.__esModule = true;
exports.applyScalarDirectives = exports.parseDate = undefined;
exports.node = node;

var _ron = require('@swarm/ron');

var _clock = require('@swarm/clock');

function node(value, isLeaf) {
  var directives = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (directives && directives.hasOwnProperty('node')) {
    if (!directives.node && typeof value === 'string') {
      return _ron.UUID.fromString(value);
    } else if (directives.node.id instanceof _ron.UUID) {
      return directives.node.id;
    } else if (typeof directives.node.id === 'string') {
      return _ron.UUID.fromString(directives.node.id);
    }
  } else if (!isLeaf && typeof value === 'string') {
    return _ron.UUID.fromString(value);
  }
  return value;
}

var parseDate = exports.parseDate = function parseDate(s) {
  var uuid = s instanceof _ron.UUID ? s : _ron.UUID.fromString(s);
  return (0, _clock.calendarBase2Date)(uuid.value);
};

var applyScalarDirectives = exports.applyScalarDirectives = function applyScalarDirectives(value) {
  var directives = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  for (var _iterator = Object.keys(directives || {}), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var key = _ref;

    switch (key) {
      case 'date':
        if (typeof value === 'string' || value instanceof _ron.UUID) value = parseDate(value.toString());
        break;
      case 'uuid':
        if (typeof value === 'string' || value instanceof _ron.UUID) value = _ron.UUID.fromString(value.toString());
        break;
    }
  }
  return value;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@swarm/db/lib/utils.js
// module id = 88
// module chunks = 0